import '../sass/text.scss';

(() => {
    const $blocks = document.querySelectorAll('.text');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $readMores = $block.querySelectorAll('.text__read-more');

        const initReadMore = () => {
            if (!$readMores) return;

            $readMores.forEach($readMore => {
                const $readMoreContent = $readMore.querySelector('.text__read-more-content');
                const $readMoreOpen = $readMore.querySelector('.text__read-more-open');
                const $readMoreOpenBtn = $readMore.querySelector('.text__read-more-open-btn');
                const $readMoreCloseBtn = $readMore.querySelector('.text__read-more-close-btn');
                        
                const readMoreContentExpandable = new Expandable($readMoreContent);
                const readMoreOpenExpandable = new Expandable($readMoreOpen);

                $readMoreOpenBtn?.addEventListener('click', () => {
                    readMoreContentExpandable.open();
                    readMoreOpenExpandable.close();
                });

                $readMoreCloseBtn?.addEventListener('click', () => {
                    readMoreContentExpandable.close();
                    readMoreOpenExpandable.open();
                });
            });
        };

        initReadMore();
    });
})();
